export default __webpack_public_path__ + "static/media/shoppingCart-heart.9320c27c.svg";